<template>
    <div
        class="w-full dashboard-templates-list relative"
        style="direction: ltr"
    >
        <DashboardTemplatesVerticalView
            v-if="!loading"
            ref="verticalViewRef"
            :template-categories="templateCategories"
            :selected-template="selectedTemplate"
            :templates-language-filter-value="languageFilterValue"
            @on-select-template="onSelectTemplate"
            @on-detailed-view="onDetailedView"
        />
        <div
            v-if="loading"
            class="absolute inset-0 flex-center bg-black/10 rounded-lg"
        >
            <Stretch
                :size="40"
            />
        </div>
        <DashboardTemplatePreviewModal
            ref="templatePreviewModalRef"
        />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { DashboardTemplateCategoryList, DashboardTemplateList } from '@/types/dashboard-template'
import DashboardTemplatesVerticalView from '@/views/DashboardCreation/components/DashboardTemplatesVerticalView.vue'
import { useVModel } from '@vueuse/core'
import Stretch from '@/components/RedesignBaseComponents/Loader/Stretch.vue'
import DashboardTemplatePreviewModal from '@/views/DashboardCreation/components/DashboardTemplatePreviewModal.vue'

/* Props */
const props = defineProps<{
    loading?: boolean
    value?: DashboardTemplateList
    languageFilterValue?: number
    templateCategories?: Array<DashboardTemplateCategoryList>
}>()
/* Emits */
const emits = defineEmits<{
    (e: 'input', value: DashboardTemplateList): void
}>()

/* Refs */
const templatePreviewModalRef = ref<typeof DashboardTemplatePreviewModal>()
const verticalViewRef = ref<InstanceType<typeof DashboardTemplatesVerticalView>>()

/* Model */
const selectedTemplate = useVModel(props, 'value', emits, { eventName: 'input' })

/* Methods */
function onSelectTemplate (templateItem: DashboardTemplateList) {
    selectedTemplate.value = { ...templateItem }
}

function onDetailedView (templateItem: DashboardTemplateList) {
    templatePreviewModalRef.value?.open(templateItem)
}

/* Expose */
defineExpose({
    selectTab: (tabName: string) => {
        verticalViewRef.value?.selectTab(tabName)
    },
    getActiveTabName: () => verticalViewRef.value?.getActiveTabName() || ''
})
</script>

